module.exports = __webpack_public_path__ + "static/media/pinwheel.dae385d9.mp3";